import D3Map from "@/components/d3-map/D3-Map.vue"
import WRF from "@/components/wrf/WRF.vue"
import EqMapView from "@/views/EqMapView.vue"
import MapView002 from "@/views/MapView002.vue"
import MapView003 from "@/views/MapView003.vue"
import MapView004 from "@/views/MapView004.vue"
import PeopleView from "@/views/PeopleView.vue"
import { createPinia } from "pinia"
import type { Component } from "vue"
import { createApp } from "vue"
// import "./assets/main.scss"

initVAC("#eqMapElement", EqMapView)
initVAC("#map-004", MapView004)
initVAC("#map-003", MapView003)
initVAC("#map-002", MapView002)
initVAC("#membermap", D3Map)
initVAC("#wrfapp", WRF)

initVAC("#vac-people", PeopleView, false)

function initVAC(selector: string, component: Component, usePinia = true): void {
  const $elements = document.querySelectorAll(selector)
  for (const $element of $elements) {
    if ($element === null) {
      continue
    }
    const app = createApp(component)
    if (usePinia === true) {
      app.use(createPinia())
    }
    app.mount($element)
  }
}
